import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, EMPTY, Observable, of, switchMap, withLatestFrom } from 'rxjs';
import { DeliveredMedicationsService } from 'src/app/services/delivered-medications/delivered-medications.service';
import { GeneralError } from 'vidis-common';
import {
  DeliveredMedicationsApiActions,
  DeliveredMedicationsStoreActions
} from '../actions/delivered-medication.action';
import { selectPatientSSIN } from '../selectors/user.selector';
import { selectDeliveredMedicationsIsLoaded } from '../selectors/delivered-medications.selector';

@Injectable()
export class DeliveredMedicationsEffects {

  constructor(
    private actions$: Actions,
    private deliveredMedicationsService: DeliveredMedicationsService,
    private store: Store
  ) {
  }

  fetchDeliveredMedications$ = createEffect(() => this.actions$.pipe(
    ofType(DeliveredMedicationsApiActions.fetchDeliveredMedications),
    withLatestFrom(
      this.store.select(selectPatientSSIN),
      this.store.select(selectDeliveredMedicationsIsLoaded)
    ),
    switchMap(([action, ssin, isLoaded]) => {
      if (!isLoaded && ssin !== undefined) {
        return this.deliveredMedicationsService.getDeliveredMedications(ssin).pipe(
          switchMap(listDeliveredMedications => [
            DeliveredMedicationsStoreActions.setDeliveredMedications({listDeliveredMedications})
          ]),
          catchError(err => this.handleError(err))
        );
      } else {
        return of(DeliveredMedicationsStoreActions.stopDeliveredMedicationsLoading());
      }
    })
  ));

  fetchCountDeliveredMedications$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeliveredMedicationsApiActions.fetchCount),
      withLatestFrom(
        this.store.select(selectPatientSSIN)
      ),
      switchMap(([action, ssin]) => {
        if (ssin !== undefined) {
          return this.deliveredMedicationsService.countDeliveredMedications(ssin).pipe(
            switchMap(countDeliveredMedication => [
              DeliveredMedicationsStoreActions.setDeliveredMedicationsCount({countDeliveredMedication})
            ]),
            catchError(err => this.handleError(err))
          );
        }
        return EMPTY;
      })
    )
  );

  private handleError(err: HttpErrorResponse): Observable<any> {
    let deliveredMedicationsError: GeneralError = { code: 'general' };
    if (err.status === 0) {
      deliveredMedicationsError.code = 'network_error';
    } else if (err?.error?.code?.includes('VIDIS')) {
      deliveredMedicationsError = err.error;
    }
    deliveredMedicationsError.traceId = err.headers?.get('trace-id');
    return of(DeliveredMedicationsStoreActions.setDeliveredMedications({
      listDeliveredMedications: {errors: [deliveredMedicationsError]}
    }));
  }
}
